/*
 * @Descripttion:
 * @version:
 * @Author: linxi
 * @email: 2194421430@qq.com
 * @Date: 2021-04-07 15:05:46
 * @LastEditors: linxi
 * @LastEditTime: 2024-06-26 10:16:13
 */
import React, { useEffect, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { storePageParams } from '../../services/storesearch'
import { AGColumns, Columns, DoctorColumns } from './columns'
import { Storesearchquery } from './query'
import {
  detailStoresearch,
  getBatchReportDamagedAsync,
  geteExportPublicDrugDirectoryAsync,
  getExportInsuranceAsync,
  getShowInventorySortAsync,
  getStoreExportAsync,
  pageStoresearch,
  pageStoresearchPrintAsync,
  selectAmountTotal,
  selectCurrent,
  selectDetail,
  selectPageLoading,
  selectStoresearchData,
  selectTotal,
  setCurrent,
  setDetail,
  setlogoutlistStateAsync,
  setPageLoading,
  setsplitOrTotalAsync,
} from './storesearchSlice'
import styles from './Storesearch.module.css'
import {
  Button,
  Col,
  Dropdown,
  Form,
  Input,
  Menu,
  Modal,
  notification,
  Popover,
  Radio,
  Row,
  Space,
  Switch,
  Table,
} from 'antd'
import { NavBar } from '../../compnents/nav/NavBar'
import { TableRowSelection } from 'antd/lib/table/interface'
import { DataType } from '../putstorage/putstorage'
import { RootDispatch } from '../../app/store'
import { useHistory, useLocation } from 'react-router-dom'
import { unwrapResult } from '@reduxjs/toolkit'
import { EditableList } from '../../compnents/list/EditableList'
import { PrintFrame, PrintFrameRef } from '../print/PrintFrame'
import { printBody } from '../../models/storesearchPrint'
import {
  selectCredentials,
  selectInsuranceArray,
  selectTenantCategory,
  selectTenantName,
  selectUserId,
  selectUserName,
} from '../../app/applicationSlice'
import { selectDurgsystemData } from '../durgsystem/durgsystemSlice'
import { BillingCategoryName } from '../../models/billingCategory'
import moment from 'moment'
import { sum } from 'lodash'
import {
  pagePutstorage,
  savelistPutstorageAsync,
} from '../putstorage/putstorageSlice'
import { ExclamationCircleFilled } from '@ant-design/icons'
import { getCouponsRecordupdateStatus } from '../coupons/coupons'
import {BaoSunIcon, ExportOutlined, PrintOutlined, TagPrint} from '../../compnents/icons/Icons'
import { getUserProfileList } from '../personalManagement/personalDetail/personalDetailSlice'
import { getPageColumnListAsync, getSubmitPageColumnListAsync } from '../transactionQuery/transactionQuerySlice'
import SimpleAgGrid from '../../compnents/simpleTable/SimpleAgGrid'
import { getSortColumnList } from '../../models/common'
import { SJQXChecks } from '../../models/dataPersion'
import { getCheckPermissionAsync } from '../FunctionSetting/dataPermission/dataPermissionSlice'
import { Checks } from '../../models/personalSetting'
import { PrintTemplateModal } from '../print/PrintTemplateModal'
import { PrintTemplateCategory } from '../../models/print'

// const getMaterialsCategoryQueryParams = (queries: storePageParams) => {
//   const materialsCategoryList = queries?.materialsCategoryList
//
//   if (queries?.materialsCategory || queries?.category) {
//     return {
//       materialsCategory: queries?.materialsCategory,
//       category: queries?.category,
//     }
//   }
//
//   if (Array.isArray(materialsCategoryList) && Array.isArray(materialsCategoryList[0])) {
//     const materialsCategory = Array.from(
//       new Set(
//         materialsCategoryList
//           .map((item: any) => item?.[0])
//           .filter((item: any) => item !== undefined && item !== null && item !== '')
//       )
//     ).join(',')
//     const category = Array.from(
//       new Set(
//         materialsCategoryList
//           .map((item: any) => item?.[1])
//           .filter((item: any) => item !== undefined && item !== null && item !== '')
//       )
//     ).join(',')
//
//     return {
//       materialsCategory: materialsCategory || undefined,
//       category: category || undefined,
//     }
//   }
//
//   return {
//     materialsCategory: Array.isArray(materialsCategoryList) ? materialsCategoryList?.[0] : undefined,
//     category: Array.isArray(materialsCategoryList) ? materialsCategoryList?.[1] : undefined,
//   }
// }

export const Storesearch = () => {
  const history = useHistory()

  const [sortedInfo, setSorter] = useState<any>()

  const location: any = useLocation()

  const dispatch = useDispatch<RootDispatch>()

  const [form] = Form.useForm()

  const [PrintForm] = Form.useForm()

  const [scrollHeight, setScrollHeight] = useState<any>()

  const [isModalVisible, setIsModalVisible] = useState(false)

  const [bottomData, setBottomData] = useState<any>()

  const [Ids, setIds] = useState('')

  const [SelectId, setSelectId] = useState(0)

  const [selectIds, setSelectIds] = useState<any>([])

  const [Text, setText] = useState('拆零')

  const [isSplitVisible, setisSplitVisible] = useState(false)

  const [printVisible, setIsPrintVisible] = useState(false)

  const [KFGZZCKLRSJData, setKFGZZCKLRSJData] = useState<any>(true)

  const [queries, setQueries] = useState<storePageParams>({
    state: 1,
    size: 10,
    showFlag: 0,
    mergeFlag: 0,
    current: 0,
  })

  const [printData, setPrintData] = useState<any>()

  const [exportLoading, setExportLoading] = useState(false)

  const [insuranceExportLoading, setInsuranceExportLoading] = useState(false)

  const [publicDrugDirectoryExportLoading, setPublicDrugDirectoryExportLoading] = useState(false)

  const [printListData, setPrintListData] = useState<any>()

  const [selectionType] = useState<'checkbox' | 'radio'>('checkbox')

  const detail: any = useSelector(selectDetail)

  // const Current = useSelector(selectCurrent);

  const total = useSelector(selectTotal)

  const data = useSelector(selectStoresearchData)

  const amountTotal = useSelector(selectAmountTotal)

  const tenantName = useSelector(selectTenantName)

  const userId = useSelector(selectUserId)

  const storehouseList: any = useSelector(selectDurgsystemData)

  const userName = useSelector(selectUserName)

  const printRef = useRef<PrintFrameRef>(null)

  const pageLoadingRX = useSelector(selectPageLoading)

  const insuranceArray = useSelector(selectInsuranceArray)

  const tenantCategory = useSelector(selectTenantCategory)

  const [allData, setAllData] = useState<any>([])

  const [isPriceTagPrintModalVisible, setIsPriceTagPrintModalVisible] = useState(false)

  // 所有的列表
  const listData: any = [
    {
      headerName: '',
      field: 'checkbox',
      checkboxSelection: true,
      headerCheckboxSelection: true,  // 启用表头复选框（全选功能）
      width: 50,
      minWidth: 50,
      pinned: 'left',// 将列固定在左侧
      lockPosition: "left", // 锁定列位置，防止列移动
      suppressMovable: true, // 防止列被拖动
      resizable: false, //防止列宽被调整
      visible: true,
    },
    {
      headerName: '序号',
      width: 62,
      minWidth: 62,
      field: 'index',
      pinned: 'left',
      lockPosition: "left",
      suppressMovable: true,
      visible: true,
    },
    {
      headerName: '商品信息',
      field: 'name',
      width: 300,
      minWidth: 300,
      pinned: 'left',
      lockPosition: "left",
      suppressMovable: true,
      visible: true,
    },
    {
      headerName: '商品类别',
      field: 'category',
      minWidth: 160,
      visible: true,
    },
    {
      headerName: '开票项目',
      field: 'billingCategory',
      minWidth: 110,
      visible: true,
    },
    {
      headerName: '所属库房',
      field: 'storehouseName',
      minWidth: 110,
      visible: true,
    },
    {
      headerName: '柜号',
      field: 'cabineNo',
      minWidth: 110,
      visible: false,
    },
    {
      headerName: '批次号',
      field: 'batchNo',
      minWidth: 110,
      visible: true,
    },
     {
      headerName: '生产日期',
      field: 'productDate',
      minWidth: 110,
      visible: true,
    },
    {
      headerName: '有效期至',
      field: 'deadline',
      minWidth: 110,
      visible: true,
    },
    {
      headerName: '拆零比例',
      field: 'splitScale',
      minWidth: 110,
      visible: true,
    },
    {
      headerName: '库存数量',
      field: 'count',
      minWidth: 110,
      sortable: true,
      visible: true,
    },
    {
      headerName: '拆零数量',
      field: 'splitCount',
      minWidth: 110,
      sortable: true,
      visible: true,
    },
    {
      headerName: '加成比例',
      field: 'additionRatio',
      minWidth: 110,
      sortable: true,
      visible: true,
    },
    {
      headerName: '进价',
      field: 'unitPrice',
      minWidth: 150,
      visible: true,
    },
    {
      headerName: '售价',
      field: 'retailPrice',
      align: 'center',
      minWidth: 150,
      visible: true,
    },
    {
      headerName: '拆零售价',
      field: 'splitPrice',
      align: 'center',
      minWidth: 150,
      visible: false,
    },
    {
      headerName: '医保限价',
      field: 'priceLimit',
      minWidth: 120,
      visible: true,
    },
    {
      headerName: '库存金额(进价)',
      field: 'total',
      minWidth: 130,
      visible: true,
    },
    {
      headerName: '库存金额(售价)',
      field: 'retailPriceTotal',
      minWidth: 130,
      visible: true,
    },
    {
      headerName: '甲乙分类',
      field: 'chrgitmLvs',
      minWidth: 110,
      visible: true,
    },
    {
      headerName: '医保国码',
      field: 'hilistCode',
      minWidth: 200,
      visible: true,
    },
    {
      headerName: '产地',
      field: 'origin',
      minWidth: 150,
      visible: true,
    },
    {
      headerName: '供应商',
      field: 'gysName',
      minWidth: 170,
      visible: true,
    },
    // 0512通用名修改 通用名->商品名
    {
      headerName: '商品名',
      field: 'genericName',
      minWidth: 150,
      visible: true,
    },
    {
      headerName: '批准文号',
      field: 'approvalNumber',
      minWidth: 150,
      visible: true,
    },
    {
      headerName: '剂型',
      field: 'doseCategory',
      minWidth: 100,
      visible: true,
    },
    {
      headerName: '单位',
      field: 'accountUnit',
      minWidth: 100,
      visible: true,
    },

    {
      headerName: '入库日期',
      field: 'inboundDate',
      minWidth: 100,
      visible: true,
    },
    {
      headerName: '国谈标志',
      field: 'natNegoDrugFlag',
      minWidth: 100,
      visible: true,
    },
    {
      headerName: '省招标志',
      field: 'provinceTendFlag',
      minWidth: 100,
      visible: true,
    },
    {
      headerName: '包装材质',
      field: 'pacmatl',
      minWidth: 100,
      visible: false,
    },
    {
      headerName: '操作',
      field: 'action',
      width: 220,
      minWidth: 220,
      pinned: 'right',
      lockPosition: "right",
      suppressMovable: true,
      visible: true,
    },
  ]?.map((v, index) => {
    return {
      ...v,
      index: index + 1,
    }
  })

  const allColumnData = listData

  // 默认要展示的列的值
  const selectColumns = allColumnData?.filter((v: any) => v.visible)?.map((item: any) => item.field) || []

  const [allColumnList, setAllColumnList] = useState<any[]>([]) //筛选列所有的数据

  const [columnQueryFilterList, setColumnQueryFilterList] = useState<any[]>([])
  
  // 筛选列所有的数据
  const [filterColumnList, setFilterColumnList] = useState<any[]>([])

  const [filterSelectList, setFilterSelectList] = useState<any[]>([]) //筛选列所有的数据
    
  const [pageSelections, setPageSelections] = useState<any>({})

  const allPersonalPreferences = JSON.parse(localStorage?.getItem('allPersonalPreferences') || '{}')

  useEffect(() => {
    if (JSON.stringify(pageSelections) != '{}') {
      const derivedSelectedKeys = Object.values(pageSelections).flat()
      const selectedRowIds = derivedSelectedKeys.map((row: any) => Number(row?.id))
      setSelectIds(selectedRowIds || [])
      setIds(selectedRowIds?.join(','))
    }
  }, [pageSelections])

  useEffect(() => {
    if (!selectIds?.length) {
      setPageSelections({})
    }
  }, [selectIds]);

  useEffect(() => {
    if (allColumnList?.length) {
      // tenantCategory == 17 校医务室
      // 医保的情况下展示全部 其余都过滤（医保限价priceLimit）
      const insuranceListData = insuranceArray.length ? allColumnList : allColumnList?.filter((v: any) => v.field !== 'priceLimit' && v.field !== 'pacmatl')
      const columnData = tenantCategory == 17 ?
        //如果是校医务室过滤 （加成比例 additionRatio  /售价 retailPrice / 库存金额(售价) retailPriceTotal / 甲乙分类 chrgitmLvs / 省招标志 provinceTendFlag / 医保国码 hilistCode / 国谈标志 natNegoDrugFlag ）
          insuranceListData?.filter((v: any) => v.field !== 'additionRatio' && v.field !== 'retailPrice'
            && v.field !== 'retailPriceTotal' && v.field !== 'chrgitmLvs' && v.field !== 'provinceTendFlag' && v.field !== 'hilistCode' && v.field !== 'natNegoDrugFlag')
          : insuranceListData
      setColumnQueryFilterList(columnData)
    }
  }, [allColumnList])

  const submitPageList = (data: any) => {
    const params = {
      pageName: 'storesearch',
      configJson: JSON.stringify(data),
    }
    dispatch(getSubmitPageColumnListAsync({
      ...params,
    }))
      .then(unwrapResult)
      .then((v: any) => {
        getPageColumnList(v?.id)
      })
  }

  const getPageColumnList = (id?: any) => {
    dispatch(getPageColumnListAsync({
      id: id ? id : undefined,
      pageName: 'storesearch',
    }))
      .then(unwrapResult)
      .then((v: any) => {
        const data: any = v?.configJson ? JSON.parse(v?.configJson) : []
        const filterList = data?.filter((n: any) => n?.visible)
        const columns = filterList?.map((n: any) => n?.field)
        const resetData = data?.map(((v: any) => {
          const sameFileds = allColumnData?.find((item: any) => item?.field == v?.field)
          return {
            ...v,
            minWidth: sameFileds?.minWidth || v?.minWidth,
            width: sameFileds?.width || v?.width,
            headerName: sameFileds?.headerName || v?.headerName,
          }
        }))
        // 所有的数据
        setAllColumnList(data?.length ? resetData : allColumnData)
        // 筛选后存在后端的数据

        setFilterColumnList(filterList?.length ? filterList : allColumnData)
        // 选中的值
        setFilterSelectList(columns?.length ? columns : selectColumns)
      })
      .catch(() => {
        setAllColumnList(allColumnData)
        setFilterColumnList(allColumnData)
        setFilterSelectList(selectColumns)
      })
      .finally(() => {
        dispatch(setPageLoading(false))
      })
  }

  const layout = {
    labelCol: { span: 6 },
    wrapperCol: { span: 18 },
  }

  const removeDuplicatesById = (arr: any[]) => {
    const map = new Map();
    arr.forEach((item: any) => {
      map.set(item.id, item);
    });
    return Array.from(map.values());
  }

  useEffect(() => {
    const newData = removeDuplicatesById([...data, ...allData])
    setAllData(newData)
  }, [data])

  const onResize = () => {
    const table = document.getElementById('tableHeightStoreSearch')
    if (table) {
      const height = table.offsetHeight - 60 - 80 - 20 - 20
      setScrollHeight(height)
    } else {
      return '100%'
    }
  }

  const getStoresearchList = () => {
    dispatch(
      pageStoresearch({
        ...queries,
        materialsCategoryList: undefined,
      })
    )
  }
  useEffect(() => {
    if (!queries.current) return
    dispatch(setPageLoading(true))
    onResize() // 初始化设置高度
    window.addEventListener('resize', onResize)
    getStoresearchList()
    getPageColumnList()
    setTimeout(() => {
      dispatch(setPageLoading(false))
    }, 3000)
    sessionStorage.setItem(
      location.pathname,
      JSON.stringify({ ...queries, category: location?.state?.category })
    )
    getShowInventorySortData()
  }, [queries])

  useEffect(() => {
    let sortN = 0
    if (sortedInfo?.order === 'ascend') {
      switch (sortedInfo?.columnKey) {
        case 'count':
          sortN = 1
          break
        case 'additionRatio':
          sortN = 3
          break
        case 'splitCount':
          sortN = 5
          break
        default:
          break
      }
    } else if (sortedInfo?.order === 'descend') {
      switch (sortedInfo?.columnKey) {
        case 'count':
          sortN = 2
          break
        case 'additionRatio':
          sortN = 4
          break
        case 'splitCount':
          sortN = 6
          break
        default:
          break
      }
    }

    if (sortedInfo && sortedInfo?.order == undefined) {
      setQueries({
        ...queries,
        sort: undefined,
      })
    } else {
      setQueries({
        ...queries,
        sort: sortN,
      })
    }
  }, [sortedInfo])

  const dataMainList = {
    tenantName: tenantName,
    userName: userName,
    KFGZZCKLRSJData: KFGZZCKLRSJData,
    dataList: printListData?.map((v: any) => {
      return {
        ...v,
        counts: sum(
          v?.value?.map((i: any) => {
            return i?.count ? Number(i?.count) : 0
          })
        ),
        splitCounts: sum(
          v?.value?.map((i: any) => {
            return i?.splitCount ? Number(i?.splitCount) : 0
          })
        ),
        totals: sum(
          v?.value?.map((i: any) => {
            return i.total > -1 ? Number(i?.total) : 0
          })
        ),
        retailPriceTotals: sum(
          v?.value?.map((i: any) => {
            return i.retailPriceTotal > -1 ? Number(i?.retailPriceTotal) : 0
          })
        ),
        value: v?.value?.map((val: any) => {
          return {
            ...val,
            billingCategory: BillingCategoryName(val?.billingCategory),
            productDate:
              val.deadline != ''
                ? val.mergeFlag
                  ? '-'
                  : moment(val.productDate).format('YYYY-MM-DD')
                : '',
            deadline:
              val.deadline != ''
                ? val.mergeFlag
                  ? '-'
                  : moment(val.deadline).format('YYYY-MM-DD')
                : '',
            count: val.count != '' ? val.count + val.accountUnit : '',
            splitCounts: val.splitCounts ? Number(val?.splitCount) : 0,
            splitCount: val.splitTag ? val.splitCount + val.splitUnit : '-',
            unitPrice: val.mergeFlag
              ? '-'
              : val.unitPrice > 0
                ? parseFloat(val.unitPrice).toFixed(5)
                : '-',
            retailPrice: val.mergeFlag
              ? '-'
              : val.retailPrice > 0
                ? parseFloat(val.retailPrice).toFixed(5)
                : '-',
            total: val.total > -1 ? val.total.toFixed(2) : '0.00',
            retailPriceTotal:
              val.retailPriceTotal > -1
                ? val.retailPriceTotal.toFixed(2)
                : '0.00',
          }
        }),
      }
    }),
    totalAmountInput:
      printListData?.[0].value?.[0].totalAmountInput?.toFixed(2) || '0.00',
    totalAmountSale:
      printListData?.[0].value?.[0].totalAmountSale?.toFixed(2) || '0.00',
    storehouseName:
      storehouseList?.filter((v: any) => v?.id == queries?.storehouseId)?.[0]
        ?.name || '-',
  }
  const content = printBody(dataMainList)

  useEffect(() => {
    // printData && printRef.current?.print();
    if (printListData) {
      const page: any = window?.open('', '_blank') // 打开一个新窗口，用于打印
      page?.document?.write(content) // 写入打印页面的内容
      page?.print() // 打印
      page?.close()
      setIsPrintVisible(false)
    }
  }, [printListData])

  const rowSelection = {
    preserveSelectedRowKeys: true,
    onChange: (selectedRowKeys: React.Key[], selectedRows: DataType[]) => {
      setSelectIds(selectedRowKeys)
      setIds(selectedRowKeys.join(','))
    },
  }

  useEffect(() => {
    form.setFieldsValue({
      invcount: detail.count,
      invSplitCount: detail.splitCount,
      splitScale: detail.splitScale,
      splitPrice: detail.splitPrice,
    })
  }, [detail])

  useEffect(() => {
    if (SelectId) {
      dispatch(detailStoresearch(SelectId))
    }
  }, [SelectId])

  useEffect(() => {
    if (printVisible) {
      PrintForm.resetFields()
      setPrintListData(undefined)
    }
  }, [printVisible])

  //批量报损
  const batchReportDamaged = () => {
    if (selectIds.length <= 0) {
      notification.info({
        message: '请选择需要报损的商品',
        duration: 3,
      })
      return
    }

    Modal.confirm({
      centered: true,
      title: '信息',
      width: 600,
      content: (
        <div>
          <span style={{ fontSize: 16, fontWeight: 'bold' }}>
            是否确认报损？
          </span>
          <p style={{ fontSize: 16 }}>
            已选中
            <span style={{ color: 'red', fontSize: 16 }}>
              {' ' + selectIds.length + ' '}
            </span>
            个商品，请确认各项信息是否正确，报损后将不可修改
          </p>
        </div>
      ),
      okText: '确认',
      cancelText: '取消',
      icon: null,
      onOk: () => {
        const inventoryLedgerList = allData?.filter((v: any) =>
          selectIds?.includes(v?.id)
        )
        dispatch(
          getBatchReportDamagedAsync({
            mergeFlag: queries.mergeFlag,
            inventoryLedgerList: inventoryLedgerList,
          })
        ).then((res: any) => {
          if (res?.payload?.length > 0) {
            dispatch(savelistPutstorageAsync(res?.payload?.join(',')))
              .then(unwrapResult)
              .then(() => {
                getStoresearchList()
                notification.success({
                  message: '批量报损成功',
                  duration: 3,
                })
              })
              .catch(() => {
                notification.error({
                  message: '报损单据生成成功 自动登账失败 请手动登账',
                  duration: 3,
                })
              })
          }
        })
      },
    })
  }

  const exportExcel = (selectIds?:any) => {
    setExportLoading(true)
    dispatch(getStoreExportAsync({...queries,materialsCategoryList: undefined,ids: selectIds?.join(',')}))
      .then(unwrapResult)
      .then((res: any) => {
        const content = res
        const blob = new Blob([content])
        const fileName = '库存导出.xlsx'
        const selfURL = window[window.webkitURL ? 'webkitURL' : 'URL']
        const elink = document.createElement('a')
        if ('download' in elink) {
          elink.download = fileName
          elink.style.display = 'none'
          elink.href = selfURL['createObjectURL'](blob)
          document.body.appendChild(elink)
          // 触发链接
          elink.click()
          selfURL.revokeObjectURL(elink.href)
          document.body.removeChild(elink)
        } else {
          return (navigator as any).msSaveBlob(blob, fileName)
        }
      })
      .then(() => {
        notification.success({
          message: '导出成功',
          duration: 3,
        })
      })
      .catch((res: any) => {
        return
      })
      .finally(() => {
        setExportLoading(false)
      })
  }

  const exportInsurance = () => {
    setInsuranceExportLoading(true)
    dispatch(getExportInsuranceAsync({...queries,materialsCategoryList: undefined}))
      .then(unwrapResult)
      .then((res: any) => {
        const content = res
        const blob = new Blob([content])
        const fileName = '医保导出.xlsx'
        const selfURL = window[window.webkitURL ? 'webkitURL' : 'URL']
        const elink = document.createElement('a')
        if ('download' in elink) {
          elink.download = fileName
          elink.style.display = 'none'
          elink.href = selfURL['createObjectURL'](blob)
          document.body.appendChild(elink)
          // 触发链接
          elink.click()
          selfURL.revokeObjectURL(elink.href)
          document.body.removeChild(elink)
        } else {
          return (navigator as any).msSaveBlob(blob, fileName)
        }
      })
      .then(() => {
        notification.success({
          message: '导出成功',
          duration: 3,
        })
      })
      .catch((res: any) => {
        return
      })
      .finally(() => {
        setInsuranceExportLoading(false)
      })
  }

  const exportPublicDrugDirectory = () => {
    setPublicDrugDirectoryExportLoading(true)
    dispatch(geteExportPublicDrugDirectoryAsync({...queries,materialsCategoryList: undefined}))
      .then(unwrapResult)
      .then((res: any) => {
        const content = res
        const blob = new Blob([content])
        const fileName = '公示药品目录导出.xlsx'
        const selfURL = window[window.webkitURL ? 'webkitURL' : 'URL']
        const elink = document.createElement('a')
        if ('download' in elink) {
          elink.download = fileName
          elink.style.display = 'none'
          elink.href = selfURL['createObjectURL'](blob)
          document.body.appendChild(elink)
          // 触发链接
          elink.click()
          selfURL.revokeObjectURL(elink.href)
          document.body.removeChild(elink)
        } else {
          return (navigator as any).msSaveBlob(blob, fileName)
        }
      })
      .then(() => {
        notification.success({
          message: '导出成功',
          duration: 3,
        })
      })
      .catch((res: any) => {
        return
      })
      .finally(() => {
        setPublicDrugDirectoryExportLoading(false)
      })
  }


  const getShowInventorySortData = () => {
    dispatch(getShowInventorySortAsync({...queries,materialsCategoryList: undefined,}))
      .then(unwrapResult)
      .then((v: any) => {
        setBottomData(v)
      })
  }

  // 库房工作站查看利润数据权限
  useEffect(() => {
    if (!location?.state?.flag) {
      dispatch(getCheckPermissionAsync({ itemCode: SJQXChecks.KFGZZCKLRSJ }))
        .then(unwrapResult)
        .then((res: any) => {
          setKFGZZCKLRSJData(res)
        })
    }else{
      setKFGZZCKLRSJData(true)
    }
  }, [location?.state?.flag])


   const exportTagMenu = (
      <Menu>
        <Menu.Item
          onClick={() => {
           if (!selectIds.length) {
             notification.info({
               message: '请先选择商品',
             })
           } else {
             // location?.state?.flag 医生工作站跳转过来的
             dispatch(getCheckPermissionAsync({ itemCode: location?.state?.flag ? SJQXChecks.YSGZZDCDYQX : SJQXChecks.KFGZZDCDYQX }))
               .then(unwrapResult)
               .then((res: any) => {
                 setExportLoading(true)
                 exportExcel(selectIds)
                 setTimeout(() => {
                   setExportLoading(false)
                 }, 5000)
               })
           }
         }}
       >
         导出勾选项
       </Menu.Item>
       <Menu.Item
         onClick={() => {
           // location?.state?.flag 医生工作站跳转过来的
           dispatch(getCheckPermissionAsync({ itemCode: location?.state?.flag ? SJQXChecks.YSGZZDCDYQX : SJQXChecks.KFGZZDCDYQX }))
             .then(unwrapResult)
             .then((res: any) => {
               setExportLoading(true)
               exportExcel()
               setTimeout(() => {
                 setExportLoading(false)
               }, 5000)
             })
         }}
       >
         导出全部查询数据
       </Menu.Item>
     </Menu>
    )
  return (
    <>
      <Col
        style={{
          margin: '10px 20px',
        }}
      >
        <NavBar
          where={['库存查询', '库存查询列表']}
          backtrace={{
            name: !location?.state?.flag ? '库房工作站' : '医生工作站',
            path: !location?.state?.flag
              ? '/storage/station'
              : '/doctor/station',
            state: {
              station: !location?.state?.flag ? '2' : '2',
            },
          }}
          buttons={
            <>
              <Space>
                {insuranceArray?.length ? <>
                  <Button
                    loading={insuranceExportLoading}
                    type='link'
                    size='small'
                    onClick={() => {
                      // 医生工作站跳转过来的location?.state?.flag
                      dispatch(getCheckPermissionAsync({ itemCode: location?.state?.flag ? SJQXChecks.YSGZZDCDYQX : SJQXChecks.KFGZZDCDYQX }))
                        .then(unwrapResult)
                        .then((res: any) => {
                          exportInsurance()
                        })
                    }}
                  >医保导出</Button>
                  <Button
                    loading={publicDrugDirectoryExportLoading}
                    type='link'
                    size='small'
                    onClick={() => {

                      dispatch(getCheckPermissionAsync({ itemCode: location?.state?.flag ? SJQXChecks.YSGZZDCDYQX : SJQXChecks.KFGZZDCDYQX }))
                        .then(unwrapResult)
                        .then((res: any) => {
                          exportPublicDrugDirectory()
                        })
                    }}
                  >公示药品目录导出</Button>
                </> :
                  <></>}
                <Dropdown overlay={exportTagMenu} trigger={['click']}>
                  <Button
                    loading={exportLoading}
                    type='text'
                    style={{
                      color: '#666',
                      display: 'flex',
                      alignItems: 'center',
                    }}
                  >
                    <ExportOutlined
                      style={{
                        fill: '#666',
                        width: '18px',
                        height: '18px',
                        marginRight: '4px',
                        paddingTop: '2px',
                      }}
                    />
                    导出
                  </Button>
                </Dropdown>
                {!location?.state?.flag && (
                  <Button
                    type='text'
                    style={{
                      color: '#666',
                      display: 'flex',
                      alignItems: 'center',
                    }}
                    onClick={() => {
                      dispatch(getCheckPermissionAsync({ itemCode: location?.state?.flag ? SJQXChecks.YSGZZDCDYQX : SJQXChecks.KFGZZDCDYQX }))
                        .then(unwrapResult)
                        .then((res: any) => {
                          setIsPrintVisible(true)
                        })
                    }}
                  >
                    <PrintOutlined
                      style={{
                        fill: '#666',
                        width: '18px',
                        height: '18px',
                        marginRight: '4px',
                      }}
                    />
                    打印
                  </Button>
                )}
                <Button
                  // loading={exportLoading}
                  type='text'
                  style={{
                    color: '#666',
                    display: 'flex',
                    alignItems: 'center',
                  }}
                  onClick={() => {
                    if (!selectIds.length) {
                      notification.info({
                        message: '请先选择商品',
                      })
                    } else {
                      setIsPriceTagPrintModalVisible(true)
                    }
                  }}
                >
                  <TagPrint
                    style={{
                      fill: '#666',
                      width: '18px',
                      height: '18px',
                      marginRight: '4px',
                      paddingTop: '2px',
                    }}
                  />
                  价格标签打印
                </Button>
                <Switch
                  size='small'
                  style={{
                    backgroundColor: queries.state ? '#FF5D5D' : '#1CD0BD',
                  }}
                  checked={(queries.state as unknown) as boolean}
                  onClick={() => {
                    if (!Ids) {
                      notification.error({
                        message: queries.state
                          ? '请选择要停用的药品!'
                          : '请选择要启用的药品',
                        duration: 3,
                      })
                    } else {
                      setIsModalVisible(true)
                    }
                  }}
                />
                {queries.state ? '停用' : '启用'}
                <Button
                  type='text'
                  style={{
                    color: '#666',
                    display: 'flex',
                    alignItems: 'center',
                  }}
                  onClick={() => batchReportDamaged()}
                >
                  <BaoSunIcon
                    style={{
                      fill: '#666',
                      width: '18px',
                      height: '18px',
                      marginRight: '4px',
                    }}
                  />
                  批量报损
                </Button>
              </Space>
            </>
          }
        />
      </Col>
      <div className={styles.content}>
        <Storesearchquery
          loading={pageLoadingRX}
          filterColumn={columnQueryFilterList}
          filterSelectList={filterSelectList}
          submitPageList={((v) => {
            dispatch(setPageLoading(true))
            submitPageList(v)
            setAllColumnList(v)
          })}
          onValueChange={(v: any) => {
            // const vs = Object.values(v);
            // if (!vs.every((item) => item === undefined)) {
            const isWubi = allPersonalPreferences?.records?.filter((v: any) => v?.code == Checks.SRFSZ)?.[0]?.codeName || 0

            setQueries({
              ...queries,
              ...v,
              isWubi: isWubi || 0,
              deadlineStart:
                v?._dateRange == 8 || v?._dateRange == 7
                  ? undefined
                  : v?.registrationTimeHead,
              deadlineEnd:
                v?._dateRange == 7 || v?._dateRange == 12
                  ? undefined
                  : v?.registrationTimeTail,
              registrationTimeHead: undefined,
              registrationTimeTail: undefined,
            })
            // }
            setSorter(undefined)
          }}
          onBatchReportDamaged={() => {
            batchReportDamaged()
          }}
          
        />
        <div
          id='tableHeightStoreSearch'
          style={{
            width: '100%',
            height: '100%',
          }}
        >
          {/* {table} */}
          <SimpleAgGrid
            rowHeight={56}
            page={{
              items: data,
              current: queries.current,
              size: queries.size || 10,
              total: total,
            }}
            column={(AGColumns(
              queries.size * ((queries.current || 1) - 1),
              (text, id, materialsCategory) => {
                switch (text) {
                  case 'detail':
                    history.push({
                      pathname: '/StoreSeaechDetail',
                      state: {
                        selectId: id,
                        flag: location?.state?.flag,
                        materialsCategory: materialsCategory,
                      },
                    })
                    break
                  case 'split':
                    setSelectId(id)
                    setText('拆零')
                    setisSplitVisible(true)
                    break
                  case 'total':
                    setSelectId(id)
                    setText('规整')
                    setisSplitVisible(true)
                    break
                  default:
                    break
                }
              },
              columnQueryFilterList,
              location?.state?.flag as number,
              queries?.mergeByName,
              KFGZZCKLRSJData
            ))?.filter((item: any) => filterSelectList?.includes(item.field))}
            isLoading={pageLoadingRX}
            pagination={true}
            pinnedBottomRowData={[{
              total: queries?.mergeByName == 1 ? '-' : amountTotal?.totalAmountInput?.toFixed(2) || '0.00',
              retailPriceTotal: queries?.mergeByName == 1 ? '-' : amountTotal?.totalAmountSale?.toFixed(2) || '0.00',
              // 剩余没有合计行的列展示为空
            }]}
            pageKey={'storesearch'}
            rowSelection="multiple"
            selectedRowKeys={selectIds}
            getRowId={(data: any) => Number(data?.id)}
            onRowDoubleClick={(event: any) => {
              const d = event?.data
              if (!d.mergeFlag) {
                history.push({
                  pathname: '/StoreSeaechDetail',
                  state: {
                    selectId: d.id,
                    flag: location?.state?.flag,
                    materialsCategory: d?.materialsCategory,
                  },
                })
              }
            }}
            onSelectionChange={(selectedRows: any, selectedNodes: any) => {
              // 更新当前页面的选中状态
              const currentPage: any = queries.current;
              setPageSelections((prev: any) => {
                // 当前页数据的 id 集合：用于区分“被搜索挤出的旧选中”与“用户主动取消”
                const currentPageDataIds = new Set(
                  (data || []).map((row: any) => Number(row?.id))
                );
                const prevCurrentPageRows = prev?.[currentPage] || [];
                const keepRows = prevCurrentPageRows.filter(
                  (row: any) => !currentPageDataIds.has(Number(row?.id))
                );
                return {
                  ...prev,
                  [currentPage]: [...keepRows, ...(selectedRows || [])],
                };
              });
            }}
            suppressRowClickSelection={true}
            // 配置底部行样式
            getRowStyle={(params) => {
              if (params.node.rowPinned) {
                return {
                  fontWeight: 'normal',
                  backgroundColor: '#D9F2FF',
                };
              }
              return {}; // 将返回 null 改为返回空对象，避免类型不匹配问题
            }}
            onChangePage={(current: any, size: any) => {
              setQueries({
                ...queries,
                current,
                size,
              })
            }}
            onColumnResized={(v: any) => {
              return
            }}
            onColumnMoved={(v) => {
              // dispatch(setPageLoading(true))
              const sortList = getSortColumnList(allColumnList, v);
              submitPageList(sortList)
              setAllColumnList(sortList)
            }}
            onSortChanged={(sortModel, hasComparator) => {
              if (hasComparator) {
                console.log("sortModel", data, sortModel, hasComparator)
              } else {
                if (sortModel && sortModel.length > 0) {
                  setSorter(sortModel?.[0])
                } else {
                  setQueries({
                    ...queries,
                    sort: undefined,
                  })
                }
              }
            }}
            sortedInfo={sortedInfo ? [sortedInfo] : []}
          ></SimpleAgGrid>
          {insuranceArray?.length ?
            <Popover
              content={
                <div
                  style={{
                    overflow: 'hidden',
                  textOverflow: 'ellipsis',
                }}
              >
                <div>
                  省招标品规数：{bottomData?.provincialCountByCode || 0}，国谈品规数：{bottomData?.countryCountByCode || 0}，省招标品种数：{bottomData?.provincialCountByName || 0}, 国谈品种数：{bottomData?.countryCountByName || 0}
                </div>
                <div>品种数：商品医保匹配的医保药品编码相同算一条</div>
                <div>品规数：商品医保匹配的医保中文名称相同算一条</div>
              </div>
              }
              placement='top'
              title='说明'
            >
              <div
                style={{
                  position: 'absolute',
                  bottom: '20px',
                  lineHeight: '60px',
                  whiteSpace: 'nowrap',
                  width: '36%',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                }}
              >
                省招标品规数：{bottomData?.provincialCountByCode || 0}，国谈品规数：{bottomData?.countryCountByCode || 0}，省招标品种数：{bottomData?.provincialCountByName || 0}, 国谈品种数：{bottomData?.countryCountByName || 0}
              </div>
            </Popover> : <></>}
        </div>
      </div>
      <Modal
        title={queries.state ? '确认停用？' : '确认启用?'}
        visible={isModalVisible}
        onOk={() => {
          setIsModalVisible(false)
          dispatch(
            setlogoutlistStateAsync({
              ids: Ids,
              state: Number(!queries.state),
              isMerge: (queries?.mergeFlag as any) == '1' ? true : false,
            })
          )
            .then(unwrapResult)
            .then(() => {
              notification.success({
                message: queries.state ? '停用成功' : '启用成功',
                duration: 3,
              })
              getStoresearchList()
            })
        }}
        onCancel={() => {
          setIsModalVisible(false)
        }}
        okText='确认'
        cancelText='取消'
      >
        <h3>{queries.state ? '确认停用？' : '确认启用'}</h3>
        {queries.state ? (
          <p>请确认各项信息是否填写正确，停用后将不可销售</p>
        ) : (
          <></>
        )}
      </Modal>
      <Modal
        title='打印类型'
        visible={printVisible}
        onOk={() => {
          PrintForm.resetFields()
          setIsPrintVisible(false)
        }}
        onCancel={() => {
          PrintForm.resetFields()
          setIsPrintVisible(false)
        }}
        okText='确认'
        cancelText='取消'
        footer={null}
      >
        <Form
          {...layout}
          autoComplete='off'
          form={PrintForm}
          name='control-hooks'
          onFinish={(vs) => {
            if (vs?.flag == 0) {
              dispatch(pageStoresearchPrintAsync({ ...queries,materialsCategoryList: undefined, }))
                .then(unwrapResult)
                .then((v: any) => {
                  const arr: any = []
                  for (let i = 0; i < Object.keys(v).length; i++) {
                    const valueList: any = Object.values(v)[i]
                    arr.push({
                      key: Object.keys(v)[i],
                      name: valueList?.[0]?.name,
                      value: valueList,
                    })
                  }
                  setPrintListData(arr)
                  setIsPrintVisible(false)
                })
            } else {
              dispatch(
                pageStoresearchPrintAsync({
                  ...queries,
                  materialsCategoryList: undefined,
                  size: 10000,
                  current: 1,
                })
              )
                .then(unwrapResult)
                .then((v: any) => {
                  const arr: any = []
                  for (let i = 0; i < Object.keys(v).length; i++) {
                    const valueList: any = Object.values(v)[i]
                    arr.push({
                      key: Object.keys(v)[i],
                      name: valueList?.[0]?.name,
                      value: valueList,
                    })
                  }
                  setPrintListData(arr)
                  setIsPrintVisible(false)
                })
            }
          }}
        >
          <Row gutter={20}>
            <Col span={24}>
              <Form.Item
                {...layout}
                name='flag'
                label='请选择打印类型'
                rules={[{ required: true, message: '打印类型不能为空!' }]}
              >
                <Radio.Group>
                  <Radio key={0} value={0}>
                    打印当页
                  </Radio>
                  <Radio key={1} value={1}>
                    打印全部
                  </Radio>
                </Radio.Group>
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={20}>
            <Col span={24}>
              <Button
                htmlType='submit'
                type='primary'
                style={{ float: 'right' }}
              >
                确认
              </Button>
            </Col>
          </Row>
        </Form>
      </Modal>
      <Modal
        title={Text}
        visible={isSplitVisible}
        onOk={() => {
          form.resetFields()
          setSelectId(0)

          setisSplitVisible(false)
        }}
        onCancel={() => {
          form.resetFields()
          setSelectId(0)

          setisSplitVisible(false)
        }}
        okText='确认'
        cancelText='取消'
        footer={null}
      >
        <Form
          {...layout}
          autoComplete='off'
          form={form}
          name='control-hooks'
          onFinish={(vs) => {
            const flag = Text === '拆零' ? 1 : 2
            if (Text === '拆零') {
              if (vs.count === undefined) {
                notification.error({
                  message: '请输入要拆零/规整的数量',
                  duration: 3,
                })
              } else if (vs.count <= vs.invcount) {
                dispatch(
                  setsplitOrTotalAsync({
                    ...vs,
                    flag,
                    tenantInventoryLedgerId: detail.id,
                  })
                )
                  .then(unwrapResult)
                  .then(() => {
                    notification.success({
                      message: '操作成功',
                      duration: 3,
                    })
                    setisSplitVisible(false)
                    getStoresearchList()
                    form.resetFields()
                    dispatch(setDetail([]))
                    setSelectId(0)
                  })
                  .catch(() => {
                    notification.error({
                      message: '请输入正确数量',
                      duration: 3,
                    })
                  })
              } else {
                notification.error({
                  message: '拆零数量不可大于现有库存',
                  duration: 3,
                })
              }
            } else {
              if (vs.count === undefined) {
                notification.error({
                  message: '请输入要拆零/规整的数量',
                  duration: 3,
                })
              } else if (vs.count * vs.splitScale <= vs.invSplitCount) {
                dispatch(
                  setsplitOrTotalAsync({
                    ...vs,
                    flag,
                    tenantInventoryLedgerId: detail.id,
                  })
                )
                  .then(unwrapResult)
                  .then(() => {
                    notification.success({
                      message: '操作成功',
                      duration: 3,
                    })
                    setisSplitVisible(false)
                    getStoresearchList()
                    form.resetFields()
                    dispatch(setDetail([]))
                    setSelectId(0)
                  })
                  .catch(() => {
                    notification.error({
                      message: '请输入正确数量',
                      duration: 3,
                    })
                  })
              } else {
                notification.error({
                  message: '规整数量乘以拆零比例不可大于现有拆零库存',
                  duration: 3,
                })
              }
            }
          }}
        >
          <Row gutter={20}>
            <Col span={24}>
              <Form.Item
                label={'需要' + Text + '数量'}
                name='count'
                rules={[
                  {
                    pattern: new RegExp(/^(([1-9]\d*)|(0{1}))(\.\d{0,2})?$/),
                    message: '请输入数字',
                  },
                ]}
              >
                <Input
                  onInput={(e: any) => {
                    if (Text === '拆零') {
                      form.setFieldsValue({
                        outCount:
                          Number(e.target.value) * Number(detail.splitScale),
                      })
                    } else {
                      form.setFieldsValue({
                        outCount:
                          Number(e.target.value) * Number(detail.splitScale),
                      })
                    }
                  }}
                />
              </Form.Item>
            </Col>
            {Text === '拆零' ? (
              <Col span={24}>
                <Form.Item label='现有库存数量' name='invcount'>
                  <Input disabled />
                </Form.Item>
              </Col>
            ) : (
              <Col span={24}>
                <Form.Item label='现有拆零库存数量' name='invSplitCount'>
                  <Input disabled />
                </Form.Item>
              </Col>
            )}
            <Col span={24}>
              <Form.Item
                label={Text === '拆零' ? '收入数量' : '支出数量'}
                name='outCount'
              >
                <Input disabled />
              </Form.Item>
            </Col>
            <Col span={24}>
              <Form.Item label={'拆零比例'} name='splitScale'>
                <Input disabled />
              </Form.Item>
            </Col>
            <Col span={24}>
              <Button
                htmlType='submit'
                type='primary'
                style={{ float: 'right' }}
              >
                确认
              </Button>
            </Col>
          </Row>
        </Form>
      </Modal>
      <PrintFrame
        ref={printRef}
        title={
          JSON.parse(localStorage.getItem('credentials') as string)?.tenantName
        }
        subTitle='库存管理'
      >
        <EditableList
          bordered
          pagination={false}
          page={{
            items: printData,
            current: queries.current,
            size: queries.size,
            total: total,
          }}
          columns={
            Columns(
              (text, id) => {
                return
              },
              location?.state?.flag as number,
              queries.size * (queries.current - 1 > 0 ? queries.current - 1 : 0)
            ).filter((v) => v.title !== '拆零比例' && v.title !== '操作')
          }
          rowClassName={(record: any) => {
            return !record.state ? styles.gray : ''
          }}
        />
        {/* <EditableList
          bordered
          page={{
            items: data,
            current: queries.current,
            size: queries.size,
            total: total,
          }}
          pagination={false}
          summary={() => (
            <Table.Summary fixed>
              <Table.Summary.Row className={styles.total}>
                <Table.Summary.Cell index={0}></Table.Summary.Cell>
                <Table.Summary.Cell index={1}>
                </Table.Summary.Cell>
                <Table.Summary.Cell index={2} align='center'>合计</Table.Summary.Cell>
                <Table.Summary.Cell index={3}>
                </Table.Summary.Cell>
                <Table.Summary.Cell index={4}>
                </Table.Summary.Cell>
                <Table.Summary.Cell index={5}></Table.Summary.Cell>
                <Table.Summary.Cell index={6}></Table.Summary.Cell>
                <Table.Summary.Cell index={9}></Table.Summary.Cell>
                <Table.Summary.Cell index={10}></Table.Summary.Cell>
                <Table.Summary.Cell index={11}></Table.Summary.Cell>
                <Table.Summary.Cell align='right' index={12}>{amountTotal?.totalAmountInput || 0}</Table.Summary.Cell>
                <Table.Summary.Cell align='right' index={13}>{amountTotal?.totalAmountSale || 0}</Table.Summary.Cell>
                <Table.Summary.Cell index={14}></Table.Summary.Cell>
              </Table.Summary.Row>
            </Table.Summary>
          )}
          rowKey={(record: any) => record.id}
          columns={
            location.state.flag
              ? DoctorColumns(
                (text, id) => {
                  switch (text) {
                    case "detail":
                      history.push({
                        pathname: "/StoreSeaechDetail",
                        state: {
                          selectId: id,
                          flag: location.state.flag,
                        },
                      });
                      // setSelectId(id);
                      // setIsVisible(true);
                      break;
                    case "split":
                      setSelectId(id);
                      setText("拆零");
                      setisSplitVisible(true);
                      break;
                    case "total":
                      setSelectId(id);
                      setText("规整");
                      setisSplitVisible(true);
                      break;
                    default:
                      break;
                  }
                },
                location.state.flag as number,
                queries.size * (queries.current - 1 > 0 ? queries.current - 1 : 0)
              )
              : Columns(
                (text, id) => {
                 return
                },
                location.state.flag as number,
                queries.size * (queries.current - 1 > 0 ? queries.current - 1 : 0)
              ).filter(v => (v.title !== '拆零比例' && v.title !== '操作'))
          }
          rowClassName={(record: any) => {
            return !record.state ? styles.gray : "";
          }}
        /> */}
      </PrintFrame>
      <PrintTemplateModal
          templateCategory={PrintTemplateCategory.Jgbqdy}
          visible={isPriceTagPrintModalVisible}
          onCancel={() => setIsPriceTagPrintModalVisible(false)}
          onOk={() => setIsPriceTagPrintModalVisible(false)}
          ids={selectIds}
          isInventoryPriceFlag={true}
      />
    </>
  )
}
